import actions from './actions';

export const fetchNoUser = () => ({type: actions.FETCH_NO_USER});
export const fetchUser = () => ({type: actions.FETCH_USER});
